import * as Yup from "yup";
import FormMeta from "../form-meta";

const idVerificationSchema = Yup.object().shape({
  [FormMeta.documentType.id]: Yup.string()
    .trim()
    .when([], {
      is: () => FormMeta.documentType.required,
      then: (schema) => schema.required("Document type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [FormMeta.documentId.id]: Yup.string()
    .trim()
    .min(FormMeta.documentId.min, "Document ID is too short")
    .max(FormMeta.documentId.max, "Document ID is too long")
    .when([], {
      is: () => FormMeta.documentId.required,
      then: (schema) => schema.required("Document ID is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [FormMeta.issuedDate.id]: Yup.string().when([], {
    is: () => FormMeta.issuedDate.required,
    then: (schema) => schema.required("Issued date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [FormMeta.expiryDate.id]: Yup.string().when([], {
    is: () => FormMeta.expiryDate.required,
    then: (schema) => schema.required("Expiry date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [FormMeta.fullName.id]: Yup.string()
    .trim()
    .min(FormMeta.fullName.min, "Name is too short")
    .max(FormMeta.fullName.max, "Name is too long")
    .when([], {
      is: () => FormMeta.fullName.required,
      then: (schema) => schema.required("Full name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  [FormMeta.dateOfBirth.id]: Yup.string().when([], {
    is: () => FormMeta.dateOfBirth.required,
    then: (schema) => schema.required("Date of birth is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default idVerificationSchema;
